/**
 * Labels for device_manage payload keys (DEVICE_MANAGE_PUBLIC_KEYS / extract_device_manage_payload).
 * Order matches backend display preference.
 */
export const CMMS_DETAIL_FIELD_ORDER: readonly { key: string; label: string }[] = [
  { key: 'device_manage_id', label: 'CMMS row id' },
  { key: 'device_manage_name', label: 'CMMS name' },
  { key: 'manufacturer', label: 'Manufacturer' },
  { key: 'cmms_status', label: 'CMMS status' },
  { key: 'cmms_category_id', label: 'Category id' },
  { key: 'cmms_device_code', label: 'Device code' },
  { key: 'cmms_power', label: 'Power' },
  { key: 'cmms_voltage', label: 'Voltage' },
  { key: 'cmms_mtbf', label: 'MTBF' },
  { key: 'cmms_lat', label: 'Latitude' },
  { key: 'cmms_lon', label: 'Longitude' },
  { key: 'cmms_updated_by', label: 'Updated by' },
  { key: 'cmms_responsible_by', label: 'Responsible by' },
  { key: 'cmms_pdf_url', label: 'PDF URL' },
  { key: 'cmms_image_url', label: 'Image URL' },
  { key: 'cmms_description', label: 'Description' },
  { key: 'cmms_pm_count', label: 'PM count' },
  { key: 'cmms_pm_last', label: 'Last PM' },
  { key: 'cmms_pm_next', label: 'Next PM' },
  { key: 'cmms_pm_interval', label: 'PM interval (days)' },
  { key: 'cmms_pm_alert_days', label: 'PM alert (days before)' },
  { key: 'cmms_uptime', label: 'Uptime (s)' },
  { key: 'cmms_downtime', label: 'Downtime (s)' },
  { key: 'cmms_health', label: 'Health (CMMS)' },
  { key: 'cmms_quantity', label: 'Quantity' },
  { key: 'cmms_price', label: 'Price' },
  { key: 'cmms_topic_name', label: 'CMMS topic name' },
  { key: 'device_manage_created_at', label: 'CMMS created at' },
  { key: 'device_manage_updated_at', label: 'CMMS updated at' },
] as const;

export function collectExtraCmmsKeys(dm: Record<string, unknown>): string[] {
  const known = new Set(CMMS_DETAIL_FIELD_ORDER.map((f) => f.key));
  return Object.keys(dm)
    .filter((k) => !known.has(k) && !k.startsWith('_'))
    .sort();
}
